exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.header[data-v-74b848c8] {\n  height: 30px;\n  background-color: #dcdee2;\n  line-height: 30px;\n  border: 0.5px solid #e8eaec;\n  text-align: left;\n  /* 缩进2个字节 */\n  text-indent: 2em;\n}\n", "", {"version":3,"sources":["/tentcoo/jenkins/workspace/epm-prod-deploy-web-pc/src/views/change-manage/RelatedRequirements.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;CAClB","file":"RelatedRequirements.vue","sourcesContent":["\n.header[data-v-74b848c8] {\n  height: 30px;\n  background-color: #dcdee2;\n  line-height: 30px;\n  border: 0.5px solid #e8eaec;\n  text-align: left;\n  /* 缩进2个字节 */\n  text-indent: 2em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74b848c8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/change-manage/RelatedRequirements.vue
// module id = /G1r
// module chunks = 6